import { EVetRecordTypeEnumDB } from 'data/types/generalTypes';

export const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const noYesTrueFalseOptions = [
  { value: false, label: 'No' },
  { value: true, label: 'Yes' },
];

export const yesNoTrueFalseOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const hasESADocumentationOptions = [
  { value: true, label: 'I have health professional documentation' },
  { value: false, label: `I don't have health professional documentation` },
];

export const isDisabilityObservableOptions = [
  {
    value: true,
    label: 'Observable',
    description:
      'My disability-related need for this dog is readily observable or visible to others.',
  },
  {
    value: false,
    label: 'Non-Observable',
    description:
      'My disability-related need for this dog is non-observable or may seem invisible to others.',
  },
];
export const isDisabilityObservableLabel =
  'Is it readily obvious that your disability requires this dog to perform tasks in order for you to function and live independently?';

export enum EText {
  DEFAULT_ERROR = 'Something went wrong',
  NETWORK_ERROR = "Couldn't reach the server. Check your connection and try again.",
  HP_FORM_TEXT = 'To verify documentation, OurPetPolicy uses a simple form for health professionals to complete with only the minimum information required to confirm an individual’s need for an assistance animal. The health professional can answer the questions on the form, by email, or by phone directly with OurPetPolicy. We will never ask for details about a patient’s disability or diagnosis.',
  HP_FORM_CREATE_TEXT = "Housing providers have the right to make the truth and accuracy of assistance animal documentation to the same extent they verify other material information during the leasing process, such as income verification. To facilitate this process for ESA and service animal letters, OurPetPolicy utilizes a simple form for the health professional to complete, which only asks the minimum information that is required to confirm an individual's need for an assistance animal as a reasonable accommodation. Health professionals are welcome to answer the questions on the form in another manner if preferred, such as over the phone or via email directly with OurPetPolicy. OurPetPolicy will never ask any details about a patient's disability or specific diagnosis. If you have any questions or concerns about this process, please contact us at support@ourpetpolicy.com.",
  VACCINATION_OTHER_NO_EXPIRE = 'Vaccination has no expiration.',
  VACCINATION_RABBIES_NO_EXPIRE = 'Documentation is from a licensed veterinarian exempting my animal from a rabies vaccination due to the animals age/health condition.',
  DONT_HAVE_CODE = 'If you do not know the code, please ask the property manager or email support@ourpetpolicy.com the adress and name of property, management company to get this code.',
  MICROCHIP_ERROR = 'This is an uncommon microchip length! Please double check the microchip.',
}

export enum EAnimalInfoContent {
  ANIMAL_VERIFIED_STATUS_INFO = 'The animal is verified as all documentation has been reviewed and verified as being valid and up to date.',
  ANIMAL_NOT_VERIFIED_STATUS_INFO = 'The animal is verified once all documentation has been reviewed and verified as being valid and up to date.',
}

export const convertedToPetNoReasonText = `The animal has not been verified as an assistance animal.   For your animal to be considered as assistance
animal, you can submit reliable documentation at
anytime by requesting to convert your animal.`;

export const vaccinationData = [
  'Rabies',
  'Spayed/Neutered',
  'Dog liability insurance',
  'City Licensing',
];

/**
 * The predefined vet-record types, mirroring `RecordPredefinedType` in
 * `shared/common-core`.
 *
 * `RecordPredefinedType.toPredefinedType` resolves an incoming name against THREE forms,
 * case-insensitively: the enum value (`RABIES`), the display name
 * (`Rabies Vaccination record`) and the normalized enum name (`Rabies`). The document
 * name field is creatable, so a resident can type any of those as a "custom" type — the
 * backend still resolves it to the predefined type and validates it as one. Matching only
 * the UI label here would leave exactly that gap open, which is the 400 this ticket exists
 * to close, so all the forms the backend accepts are listed.
 *
 * `expirable` mirrors `RecordPredefinedType.expirable()`: an expirable type must carry an
 * expiration and a non-expirable one must not, each enforced by
 * `VaccinationRecord.validateExpirability`.
 */
type TPredefinedVetRecordType = {
  value: EVetRecordTypeEnumDB;
  expirable: boolean;
  /** Every spelling the backend resolves to this type, plus the label the UI shows. */
  names: string[];
};

export const predefinedVetRecordTypes: TPredefinedVetRecordType[] = [
  {
    value: EVetRecordTypeEnumDB.Rabies,
    expirable: true,
    names: ['RABIES', 'Rabies Vaccination record', 'Rabies'],
  },
  {
    value: EVetRecordTypeEnumDB['City Licensing'],
    expirable: true,
    names: ['CITY_LICENSING', 'City Licensing'],
  },
  {
    value: EVetRecordTypeEnumDB['Spayed/Neutered'],
    expirable: false,
    names: [
      'SPAYED_NEUTERED',
      'Proof of Spay/Neuter',
      'Spayed Neutered',
      'Spayed/Neutered',
    ],
  },
  {
    value: EVetRecordTypeEnumDB['Dog liability insurance'],
    expirable: false,
    names: [
      'DOG_LIABILITY_INSURANCE',
      'Dog Bite Liability Insurance',
      'Dog Liability Insurance',
      'Dog liability insurance',
    ],
  },
];

/**
 * The predefined type the backend will resolve `typeName` to, or undefined when the name
 * is genuinely custom. Case-insensitive and whitespace-trimmed, matching `equalsIgnoreCase`.
 */
export const resolvePredefinedVetRecordType = (
  typeName: string,
): TPredefinedVetRecordType | undefined => {
  const needle = typeName.trim().toLowerCase();

  if (!needle) {
    return undefined;
  }

  return predefinedVetRecordTypes.find(type =>
    type.names.some(name => name.toLowerCase() === needle),
  );
};

/** Whether the document name the resident picked must carry an expiration date. */
export const isVetRecordExpirationRequired = (typeName: string): boolean =>
  resolvePredefinedVetRecordType(typeName)?.expirable === true;

/**
 * Whether the backend REJECTS an expiration for this document name. Non-expirable
 * predefined types must be sent with no expiration at all, so the form hides the date.
 */
export const isVetRecordExpirationBlocked = (typeName: string): boolean => {
  const predefined = resolvePredefinedVetRecordType(typeName);

  return predefined !== undefined && !predefined.expirable;
};

export const standartPlanPropertyManagements = ['Urban Land Interests'];

export const standartPlanProperties = [
  'The Townhomes at Woodmill Creek',
  'Urban Crest Lake Jackson',
  'SkyMor Cypress',
];

export const yesComminutyPropertyManagementId =
  '831019a9-49bc-436f-bcb8-f48caf22c9ca';

export const disabilityDefinition =
  "The Fair Housing Act defines a person with a disability as someone who has a mental or physical impairment that substantially limits one or more major life activities. Major life activities include but are not limited to seeing, hearing, walking, breathing, performing manual tasks, caring for one's self, learning, speaking, or working.";
